import PropTypes from 'prop-types';

export const fieldDefaultProps = {
	required: false,
	disabled: false,
	dirty: false
};

export const staticFormControlTypes = {
	tooltip: '',
	label: 'Label',
	helptext: '',
	value: 'Value',
	inline: false
};

export const fieldPropTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	required: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string,
	label: PropTypes.node,
	helptext: PropTypes.string,
	dirty: PropTypes.bool
};

export const getStorybookStaticFormControlTypes = () => {
	return {
		tooltip: {
			description: 'tooltip text',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		label: {
			description: 'static label',
			type: { name: 'node' },
			table: {
				type: {
					summary: 'node'
				}
			},
			control: { type: 'text' }
		},
		value: {
			description: 'static value',
			type: { name: 'node' },
			table: {
				type: {
					summary: 'node'
				}
			},
			control: { type: 'text' }
		},
		helptext: {
			description: 'help text',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		inline: {
			description: 'indicates if the form label and value should display inline',
			type: { name: 'bool' },
			table: {
				type: {
					summary: 'bool'
				}
			},
			control: { type: 'boolean' }
		}
	};
};

export const getStorybookFieldArgTypes = () => {
	return {
		id: {
			description: 'HTML id attribute.  Required for Accessibility',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		name: {
			description: 'HTML name attribute.  Required for validation',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		groupClassName: {
			description: 'ClassName of group.',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		required: {
			description: 'indicates if field is required',
			type: { name: 'bool' },
			table: {
				type: {
					summary: 'bool'
				},
				defaultValue: { summary: fieldDefaultProps.required }
			},
			control: { type: 'boolean' }
		},
		disabled: {
			description: 'indicates if field is disabled',
			type: { name: 'bool' },
			table: {
				type: {
					summary: 'bool'
				},
				defaultValue: { summary: fieldDefaultProps.disabled }
			},
			control: { type: 'boolean' }
		},
		tooltip: {
			description: 'tooltip text',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		label: {
			description: 'input label',
			type: { name: 'node' },
			table: {
				type: {
					summary: 'node'
				}
			},
			control: { type: 'text' }
		},
		helptext: {
			description: 'help text',
			type: { name: 'string' },
			table: {
				type: {
					summary: 'string'
				}
			},
			control: { type: 'text' }
		},
		dirty: {
			description: "true/false indicator to determine if the input has changed outside of it's initial rendering",
			type: { name: 'bool' },
			table: {
				type: {
					summary: 'bool'
				},
				defaultValue: { summary: fieldDefaultProps.dirty }
			},
			control: { type: 'boolean' }
		}
	};
};
